module.exports = __webpack_public_path__ + "1fec12389c0204348e3a67732971eaba.png";